const defaultOptions = {
  speed: 500,
  spaceBetween: 64,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2,
    loadOnTransitionStart: true,
  },
  breakpoints: {
    260: {
      slidesPerView: 1.2,
      spaceBetween: 12,
    },
    620: {
      slidesPerView: 2.1,
      spaceBetween: 16,
    },
    680: {
      slidesPerView: 2.5,
      spaceBetween: 32,
    },

    1024: {
      slidesPerView: 2.75,
      spaceBetween: 64,
      slidesOffsetBefore: 48,
      slidesOffsetAfter: 48,
    },
  },
}

const simple = {
  speed: 750,
  lazy: {
    checkInView: true,
  },
  preloadImages: false,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
}

export default {
  favorites: defaultOptions,
  offices: {
    ...defaultOptions,
    centeredSlides: true,
    loop: true,
    breakpoints: {
      ...defaultOptions.breakpoints,
      1024: {
        slidesPerView: 2.75,
        spaceBetween: 64,
      },
    },
  },
  team: {
    ...defaultOptions,
    breakpoints: {
      260: {
        slidesPerView: 1.2,
        spaceBetween: 12,
      },
      620: {
        slidesPerView: 2.1,
        spaceBetween: 16,
      },
      680: {
        slidesPerView: 2.25,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 48,
      },
    },
  },
  simple,
  'auto-height': {
    ...simple,
    autoHeight: true,
  },
  services: {
    autoHeight: true,
    speed: 500,
    spaceBetween: 32,
    breakpoints: {
      260: {
        slidesPerView: 1.2,
        spaceBetween: 12,
      },
      620: {
        slidesPerView: 1.1,
        spaceBetween: 16,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 32,
      },
    },
  },
  'main-services': {
    ...defaultOptions,
    height: 'auto',
    spaceBetween: 32,
    breakpoints: {
      260: {
        slidesPerView: 1.2,
        spaceBetween: 12,
      },
      620: {
        slidesPerView: 2.1,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 2.9,
        spaceBetween: 32,
        slidesOffsetBefore: 48,
        slidesOffsetAfter: 48,
      },
      1200: {
        slidesPerView: 3.75,
        spaceBetween: 32,
        slidesOffsetBefore: 48,
        slidesOffsetAfter: 48,
      },
    },
  },
  apartments: {
    lazy: {
      loadPrevNext: true,
    },
    slidesPerView: 1,
  },
  'apartments-thumbs': {
    speed: 500,
    init: true,
    spaceBetween: 8,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 4,
      loadOnTransitionStart: true,
    },
    slidesPerView: 2,
    breakpoints: {
      260: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 5,
      },
    },
  },
  'variable-width': {
    slidesPerView: 'auto',
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 4,
    },
    preloadImages: false,
    navigation: {
      nextEl: '[data-next]',
      prevEl: '[data-prev]',
    },
    speed: 800,
  },
}
